import api from './api';
import { AuthResponse, User } from '../types/index';

export const authService = {
  async login(email: string, senha: string): Promise<AuthResponse> {
    const response = await api.post('/auth/login', { email, senha });
    return response.data.data;
  },

  async loginWithCode(access_code: string): Promise<AuthResponse> {
    const response = await api.post('/auth/login-code', { access_code });
    return response.data.data;
  },

  async register(userData: any): Promise<User> {
    const response = await api.post('/auth/register', userData);
    return response.data.data;
  },

  async getProfile(): Promise<User> {
    const response = await api.get('/auth/me');
    return response.data.data;
  },

  async updateProfile(userData: Partial<User>): Promise<User> {
    const response = await api.put('/auth/me', userData);
    return response.data.data;
  },

  async logout(): Promise<void> {
    await api.post('/auth/logout');
  },
};
